import * as z from "zod/v4";

export const updateTicketMerchantName = {
  name: "updateTicketMerchantName" as const,
  input: z.object({ linearTicketId: z.string(), merchantName: z.string() }),
  output: z.object({ success: z.boolean(), updatedCount: z.number() }),
};
